export const SOURCE_HIGHLIGHT_LAYER_ID = "source-highlight-layer";
